/**
 * SEO 配置 - models (Bahasa Indonesia)
 */

export default {
    veo_3_1: {
        title: 'Google Veo 3.1 | WeryAI',
        description: 'Experience Google Veo 3.1 on WeryAI. High-quality results.',
        keywords: 'Google Veo 3.1, AI, WeryAI',
    },
    veo_3: {
        title: 'veo 3 | WeryAI',
        description: 'Experience veo 3 on WeryAI. High-quality results.',
        keywords: 'veo_3, AI, WeryAI',
    },
    veo_3_fast: {
        title: 'veo 3 fast | WeryAI',
        description: 'Experience veo 3 fast on WeryAI. High-quality results.',
        keywords: 'veo_3_fast, AI, WeryAI',
    },
    sora_2: {
        title: 'OpenAI Sora 2 | Generator Video AI Fisika-Akurat | WeryAI',
        description: 'Hasilkan video AI yang realistis dan akurat secara fisik menggunakan OpenAI Sora 2 dengan audio tersinkronisasi dan konsistensi narasi multi-shot.',
        keywords: 'Sora 2, OpenAI Sora, model video AI, video AI realistis, teks ke video, WeryAI',
    },
    weryai_video_1: {
        title: 'WeryAI Video 1.0 | WeryAI',
        description: 'Experience WeryAI Video 1.0 on WeryAI.',
        keywords: 'WeryAI Video 1.0, AI, WeryAI',
    },
    weryai_image_2: {
        title: 'WeryAI Image 2.0 | WeryAI',
        description: 'Experience WeryAI Image 2.0 on WeryAI.',
        keywords: 'WeryAI Image 2.0, AI, WeryAI',
    },
    image_grok_2: {
        title: 'Grok-2 | xAI | WeryAI',
        description: 'Experience Grok-2 by xAI on WeryAI.',
        keywords: 'Grok-2, xAI, AI, WeryAI',
    },
    kling_ai: {
        title: 'Kling 2.5 Turbo | Generator Video AI Sinematik | WeryAI',
        description: 'Kling 2.5 Turbo membuat video AI sinematik berkualitas tinggi dengan kontrol lensa canggih, ekspresi emosional, dan gerakan halus.',
        keywords: 'Kling 2.5 Turbo, Kling AI, video AI sinematik, model AI perfilman, kontrol lensa AI, WeryAI',
    },
    runway_ai: {
        title: 'Runway Gen-4 - Generator & Editor Video AI Canggih | WeryAI',
        description: 'Runway Gen-4 menghasilkan video AI yang realistis dan konsisten dengan pemahaman prompt lebih dalam dan alat editing cerdas. Coba gratis di WeryAI.',
        keywords: 'Runway Gen-4, Runway AI, generator video AI, teks ke video, gambar ke video, editing video AI, WeryAI',
    },
    hailuo_23: {
        title: 'hailuo 23 | WeryAI',
        description: 'Experience hailuo 23 on WeryAI. High-quality results.',
        keywords: 'hailuo_23, AI, WeryAI',
    },
    hailuo_ai: {
        title: 'Generator Video AI Hailuo - Pembuatan Video Tingkat Lanjut | WeryAI',
        description: 'Hasilkan video AI tingkat lanjut dengan Hailuo AI di WeryAI. Menampilkan kontrol gerakan mutakhir dan rendering adegan yang realistis.',
        keywords: 'Hailuo AI, MiniMax, generator video AI, kontrol gerakan, video realistis, WeryAI',
    },
    pika_2_2: {
        title: 'pika 2 2 | WeryAI',
        description: 'Experience pika 2 2 on WeryAI. High-quality results.',
        keywords: 'pika_2_2, AI, WeryAI',
    },
    seedance: {
        title: 'Generator Video Seedance AI - Kreasi Tari & Gerakan | WeryAI',
        description: 'Generator Video Seedance AI - Kreasi Tari & Gerakan on WeryAI. Realistic and professional results.',
        keywords: 'seedance, AI, WeryAI',
    },
    image_nano_banana_pro: {
        title: 'Nano Banana Pro - Generasi Gambar AI Google Gemini 3.0 Pro | WeryAI',
        description: 'Nano Banana Pro - Generasi Gambar AI Google Gemini 3.0 Pro on WeryAI. Fast and high-quality results.',
        keywords: 'nano_banana_pro, AI, WeryAI',
    },
    image_nano_banana: {
        title: 'Google Nano Banana - Menggambar Kecepatan Tinggi Gemini 2.5 Flash | WeryAI',
        description: 'Google Nano Banana - Menggambar Kecepatan Tinggi Gemini 2.5 Flash on WeryAI. Fast and high-quality results.',
        keywords: 'nano_banana, AI, WeryAI',
    },
    image_flux: {
        title: 'Generator Gambar FLUX AI - Model Gambar Open Source Teratas | WeryAI',
        description: 'Generator Gambar FLUX AI - Model Gambar Open Source Teratas on WeryAI. Fast and high-quality results.',
        keywords: 'flux, AI, WeryAI',
    },
    image_flux_kontext: {
        title: 'FLUX.1 Kontext - Peningkatan Gambar AI Profesional | WeryAI',
        description: 'FLUX.1 Kontext - Peningkatan Gambar AI Profesional on WeryAI. Fast and high-quality results.',
        keywords: 'flux_kontext, AI, WeryAI',
    },
    image_imagen: {
        title: 'Google Imagen 4 - Model Difusi Teks-ke-Gambar Canggih Google | WeryAI',
        description: 'Google Imagen 4 - Model Difusi Teks-ke-Gambar Canggih Google on WeryAI. Fast and high-quality results.',
        keywords: 'imagen, AI, WeryAI',
    },
    image_qwen_image: {
        title: 'Qwen Image - Model Rendering Teks Open Source Alibaba | WeryAI',
        description: 'Qwen Image - Model Rendering Teks Open Source Alibaba on WeryAI. Fast and high-quality results.',
        keywords: 'qwen_image, AI, WeryAI',
    },
    image_wan_ai: {
        title: 'Generasi Gambar Wan 2.5 - Model Gambar High Fidelity Alibaba | WeryAI',
        description: 'Generasi Gambar Wan 2.5 - Model Gambar High Fidelity Alibaba on WeryAI. Fast and high-quality results.',
        keywords: 'wan_ai, AI, WeryAI',
    },
    image_seendream: {
        title: 'Seedream 4.0 - Model Gambar 4K Batch ByteDance | WeryAI',
        description: 'Seedream 4.0 - Model Gambar 4K Batch ByteDance on WeryAI. Fast and high-quality results.',
        keywords: 'seendream, AI, WeryAI',
    },
    image_dreamina: {
        title: 'Dreamina 4.0 - Model Kreasi Gambar AI All-in-one ByteDance | WeryAI',
        description: 'Dreamina 4.0 - Model Kreasi Gambar AI All-in-one ByteDance on WeryAI. Fast and high-quality results.',
        keywords: 'dreamina, AI, WeryAI',
    },
    image_seedream_4_5: {
        title: 'Seedream 4.5 - Model Generasi Gambar AI Unggulan ByteDance | WeryAI',
        description: 'Seedream 4.5 adalah model gambar AI unggulan terbaru ByteDance, berfokus pada rendering tipografi presisi dan fusi multi-gambar dengan output 4K ultra HD. Coba gratis di WeryAI.',
        keywords: 'Seedream 4.5, generasi gambar AI, rendering tipografi, fusi gambar, ByteDance, kualitas 4K, WeryAI',
    },
    image_midjourney: {
        title: 'Midjourney - Gambar AI Estetika Artistik Teratas | WeryAI',
        description: 'Midjourney - Gambar AI Estetika Artistik Teratas on WeryAI. Fast and high-quality results.',
        keywords: 'midjourney, AI, WeryAI',
    },
    runway_4_5: {
        title: 'Runway Gen-4.5 Generator Video AI - Buat Video Sinematik | WeryAI',
        description: 'Buat video menakjubkan dengan Runway Gen-4.5 di WeryAI. Arsitektur hibrida autoregresif-difusi untuk simulasi fisika presisi dan konsistensi temporal.',
        keywords: 'Runway Gen-4.5, generator video AI, video AI sinematik, simulasi fisika, Runway AI, WeryAI',
    },
    kling_2_6_pro: {
        title: 'Kling 2.6 Pro Generator Video AI - Pembuatan Video Berkualitas Tinggi | WeryAI',
        description: 'Hasilkan video berkualitas tinggi dengan Kling 2.6 Pro di WeryAI. Generasi audiovisual native, kualitas sinematik 1080p, kepatuhan prompt yang sangat baik.',
        keywords: 'Kling 2.6 Pro, generator video AI, video AI berkualitas tinggi, Kling AI, WeryAI',
    },
    video_dreamina_3: {
        title: 'Dreamina 3.0 Generator Video - Kontrol kamera presisi dan panduan frame | WeryAI',
        description: 'Hasilkan video AI sinematik dengan Dreamina 3.0 (Jimeng 3.0) di WeryAI. Kontrol frame awal/akhir presisi, gerakan kamera profesional dan generasi video 1080p dinamis tinggi.',
        keywords: 'Dreamina 3.0, Jimeng Video 3.0, generator video AI, kontrol kamera, frame awal akhir, ByteDance AI, WeryAI',
    },
    kling_o1: {
        title: 'Kling O1 Generator Video AI - Generasi Video Kreatif | WeryAI',
        description: 'Lepaskan kreativitas Anda di WeryAI dengan generator video AI Kling O1. Sempurna untuk menghasilkan konten video imajinatif dan unik.',
        keywords: 'Kling O1, generator video AI, video AI kreatif, Kling AI, WeryAI',
    },
}
